var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0023 21.1917C8.32025 21.1842 5.33562 18.2029 5.32812 14.525V7.31902C5.32812 3.63362 8.31275 0.652344 12.0023 0.652344C15.6918 0.652344 18.6764 3.63362 18.6764 7.31902V14.525C18.6689 18.2029 15.6843 21.1842 12.0023 21.1917ZM12.0023 3.04935C9.64008 3.04935 7.72782 4.95947 7.72782 7.31902V14.525C7.72782 16.8846 9.64008 18.7947 12.0023 18.7947C14.3645 18.7947 16.2767 16.8846 16.2767 14.525V7.31902C16.2767 4.96696 14.3645 3.05684 12.0023 3.04935Z",
    fill: "#C6C7C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.643 16.9965C22.0206 16.7717 21.3307 17.1013 21.1057 17.7231C20.1308 20.4497 17.9861 22.592 15.2564 23.5658C14.1991 23.9403 13.1267 24.1276 12.0693 24.1351C12.0468 24.1351 12.0243 24.1351 12.0018 24.1351C11.9793 24.1351 11.9493 24.1351 11.9268 24.1425C7.98984 24.1126 4.3078 21.6556 2.89798 17.7305C2.67301 17.1088 1.99059 16.7792 1.36067 17.004C0.73825 17.2287 0.408292 17.9103 0.633264 18.5395C2.22306 22.9515 6.19756 26.0152 10.7945 26.4721V29.4534C10.7945 30.1126 11.3344 30.6519 11.9943 30.6519C12.6543 30.6519 13.1942 30.1126 13.1942 29.4534V26.4721C17.7986 26.0077 21.7731 22.9515 23.3629 18.5395C23.5954 17.9028 23.2654 17.2212 22.643 16.9965Z",
    fill: "#C6C7C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoice);
export default __webpack_public_path__ + "static/media/voice.b01cf3952b09953f4661ca54d60185a4.svg";
export { ForwardRef as ReactComponent };